/**
 * Session Countdown Timer
 * Displays an animated countdown when 10 minutes remain before session timeout
 */

(function() {
    'use strict';

    // Configuration
    const SESSION_LIFETIME = parseInt(window.SESSION_LIFETIME || 120) * 60 * 1000; // Convert minutes to milliseconds
    const WARNING_TIME = 10 * 60 * 1000; // 10 minutes in milliseconds
    const UPDATE_INTERVAL = 1000; // Update every second
    
    let sessionStartTime = Date.now();
    let countdownInterval = null;
    let isCountdownVisible = false;
    let lastActivity = Date.now();
    
    // Create countdown HTML structure
    function createCountdownHTML() {
        const html = `
            <div id="session-countdown-banner" class="session-countdown-banner" style="display: none;">
                <div class="session-countdown-content">
                    <div class="session-countdown-message">
                        Your session will expire in <span id="countdown-minutes">10</span>:<span id="countdown-seconds">00</span>
                    </div>
                    <button id="keep-session-alive-btn" class="btn btn-light btn-sm">
                        Refresh Session
                    </button>
                </div>
            </div>
        `;
        
        // Add to body
        document.body.insertAdjacentHTML('afterbegin', html);
    }
    
    // Format time for display
    function formatTime(milliseconds) {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        
        return {
            minutes: String(minutes).padStart(2, '0'),
            seconds: String(seconds).padStart(2, '0'),
            text: minutes > 1 ? `${minutes} minutes` : minutes === 1 ? '1 minute' : `${seconds} seconds`
        };
    }
    
    // Update countdown display
    function updateCountdown() {
        const now = Date.now();
        const elapsed = now - sessionStartTime;
        const remaining = SESSION_LIFETIME - elapsed;
        
        // Check if we should show the countdown
        if (remaining <= WARNING_TIME && remaining > 0) {
            if (!isCountdownVisible) {
                showCountdown();
            }
            
            const time = formatTime(remaining);
            
            // Update timer display
            document.getElementById('countdown-minutes').textContent = time.minutes;
            document.getElementById('countdown-seconds').textContent = time.seconds;
            
        } else if (remaining <= 0) {
            // Session expired
            clearInterval(countdownInterval);
            window.location.href = '/logout';
        } else if (isCountdownVisible) {
            // Hide countdown if more than 10 minutes remain
            hideCountdown();
        }
    }
    
    // Show countdown banner
    function showCountdown() {
        const banner = document.getElementById('session-countdown-banner');
        if (banner) {
            banner.style.display = 'block';
            setTimeout(() => {
                banner.classList.add('show');
            }, 10);
            isCountdownVisible = true;
        }
    }
    
    // Hide countdown banner
    function hideCountdown() {
        const banner = document.getElementById('session-countdown-banner');
        if (banner) {
            banner.classList.remove('show');
            setTimeout(() => {
                banner.style.display = 'none';
            }, 300);
            isCountdownVisible = false;
        }
    }
    
    // Refresh session via AJAX
    function refreshSession() {
        fetch('/session/refresh', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Reset session timer
                sessionStartTime = Date.now();
                hideCountdown();
                
                // Show success notification
                if (typeof toastr !== 'undefined') {
                    toastr.success('Session refreshed successfully');
                }
            }
        })
        .catch(error => {
            console.error('Error refreshing session:', error);
            if (typeof toastr !== 'undefined') {
                toastr.error('Failed to refresh session. Please try again.');
            }
        });
    }
    
    // Track user activity
    function trackActivity() {
        lastActivity = Date.now();
        
        // Reset session start time if user is active
        const timeSinceStart = Date.now() - sessionStartTime;
        if (timeSinceStart > SESSION_LIFETIME - WARNING_TIME && !isCountdownVisible) {
            // User was active, reset the timer
            sessionStartTime = Date.now();
        }
    }
    
    // Initialize
    function init() {
        // Create countdown HTML
        createCountdownHTML();
        
        // Add CSRF token meta tag if it doesn't exist
        if (!document.querySelector('meta[name="csrf-token"]')) {
            const token = document.querySelector('input[name="_token"]')?.value || 
                         window.Laravel?.csrfToken || 
                         '';
            if (token) {
                const meta = document.createElement('meta');
                meta.name = 'csrf-token';
                meta.content = token;
                document.head.appendChild(meta);
            }
        }
        
        // Bind events
        document.getElementById('keep-session-alive-btn').addEventListener('click', function() {
            refreshSession();
        });
        
        // Track user activity
        ['mousedown', 'keypress', 'scroll', 'touchstart'].forEach(event => {
            document.addEventListener(event, trackActivity, { passive: true });
        });
        
        // Start countdown timer
        countdownInterval = setInterval(updateCountdown, UPDATE_INTERVAL);
        
        // Initial check
        updateCountdown();
    }
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();